export default "__VITE_ASSET__ea8179ba__"